// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"8e692d95be1b2e609a11","715":"3d9373805ac79a9deef0","962":"5e2fc6d6423bef497b50"}[chunkId] + ".css";
};